var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhonePreviewDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 5,
    viewBox: "0 0 19 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60352 2.71045C4.60352 3.81502 3.70809 4.71045 2.60352 4.71045C1.49895 4.71045 0.603516 3.81502 0.603516 2.71045C0.603516 1.60588 1.49895 0.710449 2.60352 0.710449C3.70809 0.710449 4.60352 1.60588 4.60352 2.71045Z",
    fill: "#C4C4C4",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6035 2.71045C11.6035 3.81502 10.7081 4.71045 9.60352 4.71045C8.49895 4.71045 7.60352 3.81502 7.60352 2.71045C7.60352 1.60588 8.49895 0.710449 9.60352 0.710449C10.7081 0.710449 11.6035 1.60588 11.6035 2.71045Z",
    fill: "#C4C4C4",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6035 2.71045C18.6035 3.81502 17.7081 4.71045 16.6035 4.71045C15.4989 4.71045 14.6035 3.81502 14.6035 2.71045C14.6035 1.60588 15.4989 0.710449 16.6035 0.710449C17.7081 0.710449 18.6035 1.60588 18.6035 2.71045Z",
    fill: "#C4C4C4",
    fillOpacity: 0.75
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhonePreviewDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-preview-dots.115d452cadc29e7ddc96760bd47b9c5b.svg";